const SalesReportIcon = () => (
  <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
    <g fill="currentColor">
      <rect x="6" y="17" width="16" height="2" rx="1" />
      <rect x="7" y="8" width="4" height="11" rx="1" />
      <rect x="12" y="3" width="4" height="16" rx="1" />
      <rect x="17" y="10" width="4" height="8" rx="1" />
    </g>
  </svg>
)

export default SalesReportIcon
